import { combineEpics } from 'redux-observable';

import pageReady from './page-ready';
import queryChanged from './query-changed';
import retrieveDashboards from './retrieve-dashboards';

export default combineEpics(queryChanged, retrieveDashboards, pageReady);
